module.exports = __webpack_public_path__ + "static/media/accessory30.a9ec38c2.webp";